// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';

export const disconnectAppUserPathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
  app_id: z.number().int().describe("App id"),
  app_user_id: z.number().int().describe("AppUser id"),
});

export const disconnectAppUserHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description Integration disconnected
 */
export const disconnectAppUser200Schema = z.object({});

/**
 * @description AppUser not found
 */
export const disconnectAppUser404Schema = z.lazy(() => v1NotFoundErrorSchema);

export const disconnectAppUserMutationResponseSchema = z.lazy(() => disconnectAppUser200Schema);
